import React, { PureComponent } from 'react'
import { Button} from 'antd'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { getQueryString } from '../../utils/tool'

@observer
class Home extends PureComponent {
	@observable rstCode = ''
	@observable mbrCode = ''
	@observable accountNm = ''
	@observable account = ''
	@observable platCusNO = ''

	componentDidMount(){
		this.rstCode = getQueryString(this.props.history.location.search,'rstCode')
		this.mbrCode = getQueryString(this.props.history.location.search,'mbrCode')
		this.accountNm = getQueryString(this.props.history.location.search,'accountNm')
		this.account = getQueryString(this.props.history.location.search,'account')
		this.platCusNO = getQueryString(this.props.history.location.search,'platCusNO')
	}

	render() {
		const { rstCode,mbrCode,accountNm,account,platCusNO} = this
		return (
			<div className="page_content">
				<div className='status'>当前状态：{rstCode === '0' ?'审核通过':rstCode === '1' ? '审核中':'失败'}</div>
				<div className='info'>存管系统用户编号：{mbrCode}</div>
				<div className='info'>交易平台用户编号：{platCusNO}</div>
				<div className='info'>账户户名：{accountNm}</div>
				<div className='info'>账号：{account}</div>
				<div style={{textAlign:'center'}}>
					<Button type='primary' className='btn' onClick={()=>this.props.history.push(`/home`)}>返回首页</Button>
				</div>
			</div>
		)
	}
}
export default Home
